import dayjs from 'dayjs'
import { AccountDetails } from '../types'
import { DAY_LIMIT_FOR_BEST_RATE_GUARANTEE } from './constants'

export const pastBestRate = (account: AccountDetails): boolean => {
  const isBestRateQualified =
    account.accountType === 'CDA' && !account.retirementAccountIndicator

  const isOutsideBestRateWindow = (): boolean => {
    const openingDate = dayjs(account.acctOpenDate)
    const differenceInDays = dayjs().diff(openingDate, 'days')

    return differenceInDays > DAY_LIMIT_FOR_BEST_RATE_GUARANTEE
  }

  return isBestRateQualified && isOutsideBestRateWindow()
}
